var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"full-h",attrs:{"justify-center":"","align-center":"","fill-height":""}},[_c('v-icon',{attrs:{"color":"primaryred","x-large":"","left":""}},[_vm._v(" mdi-alert-octagon ")]),_c('p',{staticClass:"mb-0 text-h5",attrs:{"color":"error"}},[_vm._v(" "+_vm._s(_vm.$t("You have no permission to view this page"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }